class TabsComparison extends HTMLElement {
  constructor() {
    super();
    this.navItems = this.querySelectorAll('.tabs-comparison__nav-item');
    this.panels = this.querySelectorAll('.tabs-comparison__panel');
    this.lineActive = this.querySelector('.tabs-comparison__nav-line-active');
    
    this.init();
  }

  init() {
    this.navItems.forEach((item, index) => {
      item.addEventListener('click', () => this.switchTab(index));
    });

    // Handle Shopify Theme Editor events
    document.addEventListener('shopify:block:select', (event) => {
      const index = Array.from(this.navItems).findIndex(item => item.id.includes(event.detail.blockId));
      if (index !== -1) this.switchTab(index);
    });
    
    // Initial line positioning
    this.updateLine(0);
  }

  switchTab(index) {
    this.navItems.forEach((nav, i) => {
      const isActive = i === index;
      nav.classList.toggle('is-active', isActive);
      nav.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.updateLine(index);
  }

  updateLine(index) {
    if (!this.lineActive) return;
    const width = 100 / this.navItems.length;
    this.lineActive.style.width = `${width}%`;
    this.lineActive.style.left = `${width * index}%`;
  }
}

if (!customElements.get('tabs-comparison')) {
  // Use a custom element if wanted, but simpler to just use class and selector
  // Actually, I'll just use a standard selector-based initialization for compatibility
}

// Standard initialization
document.addEventListener('DOMContentLoaded', () => {
  const init = () => {
    const containers = document.querySelectorAll('.tabs-comparison');
    containers.forEach(container => {
      const navItems = container.querySelectorAll('.tabs-comparison__nav-item');
      const panels = container.querySelectorAll('.tabs-comparison__panel');
      const lineActive = container.querySelector('.tabs-comparison__nav-line-active');

      const updateLine = (index, skipScroll = false) => {
        if (!lineActive) return;
        const activeNav = navItems[index];
        const navContainer = container.querySelector('.tabs-comparison__nav');
        const lineBg = container.querySelector('.tabs-comparison__nav-line-bg');
        
        // Ensure background line spans the full scrollable width
        if (lineBg) {
          lineBg.style.width = `${navContainer.scrollWidth}px`;
        }
        
        // Calculate width and position based on pixels to ensure "full width" per tab
        const width = activeNav.offsetWidth;
        const left = activeNav.offsetLeft;
        
        lineActive.style.width = `${width}px`;
        lineActive.style.left = `${left}px`;

        if (skipScroll) return;

        // Scroll active tab into view
        navContainer.scrollTo({
          left: activeNav.offsetLeft - (navContainer.offsetWidth / 2) + (activeNav.offsetWidth / 2),
          behavior: 'smooth'
        });
      };

      const switchTab = (index, skipScroll = false) => {
        if (index < 0 || index >= navItems.length) return;
        
        navItems.forEach((nav, i) => {
          const isActive = i === index;
          nav.classList.toggle('is-active', isActive);
          nav.setAttribute('aria-selected', isActive);
        });

        panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        updateLine(index, skipScroll);
      };

      let isScrolling = false;
      navItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          isScrolling = true;
          switchTab(index);
          setTimeout(() => { isScrolling = false; }, 500);
        });
      });

      // Drag to select logic for mobile
      const navScrollContainer = container.querySelector('.tabs-comparison__nav');
      let scrollTimeout;
      
      navScrollContainer.addEventListener('scroll', () => {
        if (isScrolling || window.innerWidth > 767) return;
        
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = navScrollContainer.scrollLeft;
          const itemWidth = navItems[0].offsetWidth;
          const newIndex = Math.round(scrollLeft / itemWidth);
          
          const currentIndex = Array.from(navItems).findIndex(item => item.classList.contains('is-active'));
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < navItems.length) {
            switchTab(newIndex, true); // skipScroll = true because we are already scrolling
          }
        }, 100);
      });

      // Handle Shopify Theme Editor selection
      container.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const index = Array.from(navItems).findIndex(item => item.getAttribute('id').includes(blockId));
        if (index !== -1) switchTab(index);
      });
      
      // Initialize first tab line
      updateLine(0);
    });
  };

  init();
  
  // Re-init for theme editor if needed
  document.addEventListener('shopify:section:load', init);
});
